import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { publicPaths } from '../../routes/paths';

const TONE = {
  page: 'text-brand-700 focus-visible:ring-brand-600 dark:text-brand-400 dark:focus-visible:ring-brand-400',
  onDark: 'text-white focus-visible:ring-white',
} as const;

/** The way back to the club's home page from any public page reached from it (27/10/2026). */
export function BackHome({ tone = 'page', className = '' }: { tone?: keyof typeof TONE; className?: string }) {
  return (
    <Link
      to={publicPaths.home}
      viewTransition
      className={`-my-2 inline-flex items-center gap-1.5 rounded py-2 text-sm font-semibold hover:underline focus-visible:outline-none focus-visible:ring-2 ${TONE[tone]} ${className}`}
    >
      <ArrowLeft size={15} aria-hidden /> Về trang chủ
    </Link>
  );
}
